<ng-container *ngIf="bookingEditor.editorType === 'smallEditor' || !bookingEditor.editorType">
  <div class="card-header">
    <div>
      <h3>
        <sb-action-required [bookingStatus]="bookingEditor?.editingRecord?.data?.commercial?.bookingStatus"
                            class="mr-3"></sb-action-required>
        <span
          [innerHTML]="bookingEditor?.editingRecord?.name ? (bookingEditor?.editingRecord?.name | truncate : 20) : 'lang.globals.newCommercial' | translate"></span>
      </h3>
      <small style="color: #6993ff!important;"><a (click)="toggleEditor()"
                                                  class="link">{{'lang.bookingEditor.commercialEditor.switchToExpertMode' | translate}}</a></small>
    </div>
    <div class="header-more">
      <button (click)="bookingEditor.cancelCommercialEdit()" class="btn btn-hover-primary">
        <sb-icon class="icon-in-btn" icon="cancel"></sb-icon>
      </button>
    </div>
  </div>
  <div class="card-body">
    <sb-commercial-editor-forms (formIsValid)="setFormState($event)"></sb-commercial-editor-forms>
  </div>
  <div class="card-footer d-flex">
    <button (click)="bookingEditor.cancelCommercialEdit()" class="btn btn-default w-100 mr-2 font-weight-bolder"
            type="submit">{{'lang.globals.cancel' | translate}}</button>
    <button (click)="saveForm()"
            (keydown.enter)="saveForm()"
            [disabled]="!formIsValid" class="btn btn-success w-100 ml-2 font-weight-bolder"
            ngbTooltip="{{bookingEditor.editingRecord?.data?.commercial?.name === '' ? ('lang.globals.valueInvalid' |translate) : ''}}"
            placement="top" container="body"
            type="submit">{{'lang.globals.submit' | translate}}</button>
    <a
      *ngIf="bookingEditor?.editingRecord?.data?.commercial && bookingEditor?.editingRecord?.data?.commercial?.requirements && bookingEditor?.editingRecord?.data?.commercial?.requirements[0]?.mediumGroups.length"
      [class.disabled]="showShareOfVoice"
      [ngbTooltip]="'lang.reporting.showShareOfVoice' | translate"
      [queryParams]="{field: 'mediumGroup', id: bookingEditor?.editingRecord?.data?.commercial?.requirements[0]?.mediumGroups[0]?.id, from: bookingEditor?.editingRecord?.data?.commercial?.from?.value.toFormat('yyyy-MM-dd'), till: bookingEditor?.editingRecord?.data?.commercial?.till?.value.toFormat('yyyy-MM-dd')}"
      [sbRouterLink]="util.RoutingID.shareOfVoice" class="ml-3"
      container="body"
      placement="right"
      target="_blank">
      <button class="btn btn-info w-100 font-weight-bolder" type="submit">
        <sb-icon icon="pieChartStake"></sb-icon>
      </button>
    </a>
  </div>
</ng-container>


<ng-container *ngIf="bookingEditor.editorType === 'bigEditor'">
  <div class="card-header">
    <div>
      <h3>
        <sb-action-required [bookingStatus]="bookingEditor?.editingRecord?.data?.commercial?.bookingStatus"
                            class="mr-3"></sb-action-required>
        <span
          [innerHTML]="bookingEditor?.editingRecord?.name ? (bookingEditor?.editingRecord?.name | truncate : 60) : 'New Commercial'"></span>
      </h3>
      <small style="color: #6993ff!important;"><a (click)="toggleEditor()"
                                                  class="link">{{'lang.bookingEditor.commercialEditor.switchToEasyMode' | translate}}</a></small>
    </div>
    <div class="header-more">
      <nav #nav="ngbNav" class="nav-tabs" ngbNav>
        <ng-container ngbNavItem>
          <a ngbNavLink>
            <sb-icon class="mr-2" icon="basicSettings"></sb-icon>
            {{'lang.globals.settings' | translate}}</a>
          <ng-template ngbNavContent>
            <sb-commercial-editor-forms (formIsValid)="setFormState($event)"></sb-commercial-editor-forms>
          </ng-template>
        </ng-container>
        <ng-container
          *ngIf="bookingEditor?.editingRecord?.get('commercial')?.requirementCount > 1"
          ngbNavItem>
          <a ngbNavLink>
            <sb-icon class="mr-2" icon="crossway"></sb-icon>
            {{'lang.globals.requirements' | translate}}</a>
          <ng-template ngbNavContent>
            <sb-loading-spinner *ngIf="loadingRequirements">

            </sb-loading-spinner>
            <sb-commercial-editor-requirements *ngIf="!loadingRequirements"></sb-commercial-editor-requirements>
          </ng-template>
        </ng-container>
        <ng-container
          *ngIf="bookingEditor?.editingRecord?.get('commercial')?.requirementCount === 1"
          ngbNavItem>
          <a ngbNavLink>
            <sb-icon class="mr-2" icon="bookings"></sb-icon>
            {{'lang.globals.bookings' | translate}}</a>
          <ng-template ngbNavContent>
            <sb-loading-spinner *ngIf="loadingRequirements">

            </sb-loading-spinner>
            <sb-comp-requirement-booking-assignment
              *ngIf="!loadingRequirements"
              (bookingsChanged)="updateBookings($event)"
              [duration]="commercialData?.duration"
              [isInIntegratedContext]="true" [customer]="bookingEditor.customer"
              [planningId]="bookingEditor.planningId"
              [readonlyCommercial]="bookingEditor.readonly || bookingEditor?.editingRecord?.data?.commercial?.overwrites || this.bookingEditor?.editingRecord.get('commercial')?.planning === false"
              [requirementData]="bookingEditor?.editingRecord?.data?.commercial?.requirements[0]"></sb-comp-requirement-booking-assignment>
          </ng-template>
        </ng-container>
      </nav>
      <button (click)="bookingEditor.cancelCommercialEdit()" class="btn btn-hover-primary">
        <sb-icon class="icon-in-btn" icon="cancel"></sb-icon>
      </button>
    </div>
  </div>
  <div [ngbNavOutlet]="nav" class="card-body" style="height: 544px; overflow:auto;"></div>
  <div class="card-footer d-flex">
    <button (click)="bookingEditor.cancelCommercialEdit()" class="btn btn-default w-100 mr-2 font-weight-bolder"
            type="submit">{{'lang.globals.cancel' | translate}}</button>
    <button (click)="saveForm()" container="body"
            (keydown.enter)="saveForm()"
            [disabled]="!formIsValid" class="btn btn-success w-100 ml-2 font-weight-bolder"
            ngbTooltip="{{bookingEditor.editingRecord?.data?.commercial?.name === '' ? ('lang.globals.valueInvalid' |translate) : ''}}"
            placement="top"
            type="submit">{{'lang.globals.submit' | translate}}</button>
  </div>
</ng-container>
